import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["blockModal", "alertModal", "confirmInput"]
  static values = {
    lastPaymentAt: String,
    memberName: String,
    url: String,
    blocked: Boolean
  }

  connect() {
    this.checkPaymentWindow()
  }

  checkPaymentWindow() {
    if (!this.lastPaymentAtValue) {
      this.blockedValue = false
      return
    }

    const lastPaymentTime = new Date(this.lastPaymentAtValue)
    const now = new Date()
    const hoursSincePayment = (now - lastPaymentTime) / (1000 * 60 * 60)

    this.blockedValue = hoursSincePayment < 24
  }

  handleClick(event) {
    event.preventDefault()

    if (this.blockedValue) {
      this.showBlockModal()
    } else {
      this.showAlertModal()
    }
  }

  showBlockModal() {
    if (!this.hasBlockModalTarget) return

    const lastPaymentTime = new Date(this.lastPaymentAtValue)
    const now = new Date()
    const hoursRemaining = 24 - Math.floor((now - lastPaymentTime) / (1000 * 60 * 60))
    const minutesRemaining = 60 - Math.floor(((now - lastPaymentTime) / (1000 * 60)) % 60)

    const timeMessage = hoursRemaining > 0
      ? `${hoursRemaining} hour${hoursRemaining !== 1 ? 's' : ''} and ${minutesRemaining} minute${minutesRemaining !== 1 ? 's' : ''}`
      : `${minutesRemaining} minute${minutesRemaining !== 1 ? 's' : ''}`

    this.blockModalTarget.querySelector('[data-time-remaining]').textContent = timeMessage
    this.blockModalTarget.classList.remove('hidden')
    this.blockModalTarget.setAttribute('aria-hidden', 'false')
    document.body.classList.add('overflow-hidden')
  }

  showAlertModal() {
    if (!this.hasAlertModalTarget) return

    this.alertModalTarget.classList.remove('hidden')
    this.alertModalTarget.setAttribute('aria-hidden', 'false')
    document.body.classList.add('overflow-hidden')
  }

  closeBlockModal(event) {
    if (event) event.preventDefault()
    if (!this.hasBlockModalTarget) return

    this.blockModalTarget.classList.add('hidden')
    this.blockModalTarget.setAttribute('aria-hidden', 'true')
    document.body.classList.remove('overflow-hidden')

    if (this.hasConfirmInputTarget) {
      this.confirmInputTarget.value = ''
    }
  }

  closeAlertModal(event) {
    if (event) event.preventDefault()
    if (!this.hasAlertModalTarget) return

    this.alertModalTarget.classList.add('hidden')
    this.alertModalTarget.setAttribute('aria-hidden', 'true')
    document.body.classList.remove('overflow-hidden')
  }

  proceedWithPayment(event) {
    event.preventDefault()

    if (!this.hasConfirmInputTarget) return

    const input = this.confirmInputTarget.value.trim().toLowerCase()

    if (input === 'proceed') {
      window.location.href = this.urlValue
    } else {
      this.confirmInputTarget.classList.add('border-red-500')
      setTimeout(() => {
        this.confirmInputTarget.classList.remove('border-red-500')
      }, 500)
    }
  }

  confirmPayment(event) {
    event.preventDefault()
    window.location.href = this.urlValue
  }

  disconnect() {
    document.body.classList.remove('overflow-hidden')
  }
}
